export default {
  id: null,
  empresaID: null,
  codigo: null,
  nome: null,
  entidade: null,
  etapaID: null,
  status: 1,
  pertenceFatBasico: true,
  itens: []
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/pcidictionarymodel.js